import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    marginTop: theme.spacing(4),
  },
  switchBanner: {
    display: 'flex',
    padding: theme.spacing(2.5, 4),
    background: theme.palette.bg.main,
    borderRadius: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  bannerDescription: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: theme.spacing(3),
    color: theme.palette.labraText.primary,
  },
  hostWithLabra: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
  },
  subHeadingContainer: {
    margin: theme.spacing(3, 0, 5, 0),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
  },
  subHeading: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.tertiary,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  note: {
    fontWeight: 500,
  },
}))
